<template>
  <div v-title="$route.meta.title">
    <div class="page-heading">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item to="/">首页</el-breadcrumb-item>
        <el-breadcrumb-item>所有批量任务</el-breadcrumb-item>
        <el-breadcrumb-item>{{ $route.meta.title }}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <layout-panel :collapse="false">
      <template slot="header">搜索</template>
      <el-form :model="search"
               ref="searchForm"
               label-width="96px"
               label-position="right"
               size="medium"
               @submit.native.prevent="onSearch()">
        <div class="re-el-form__flex">
          <el-form-item label="任务类型"
                        prop="task_type">
            <el-select v-model="search.task_type"
                       placeholder="请选择"
                       class="width-max"
                       @change="onChangeSelectTaskType"
                       clearable>
              <el-option v-for="item in all_tasks"
                         :key="item.value"
                         :label="item.label"
                         :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="所属队列"
                        prop="collection_type">
            <el-select v-model="search.collection_type"
                       placeholder="请选择"
                       class="width-max"
                       @change="onChangeSelectCollectionType"
                       clearable>
              <el-option v-for="item in all_collections"
                         :key="item.collection_id"
                         :label="item.collection_name"
                         :value="item.collection_id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="状态"
                        prop="status">
            <el-select v-model="search.status"
                       style="width: 100%;"
                       clearable>
              <el-option v-for="({label, value}) in status"
                         :value="value"
                         :label="label"
                         :key="value" />
            </el-select>
          </el-form-item>
        </div>
        <el-form-item>
          <el-button type="primary"
                     icon="el-icon-search"
                     native-type="submit">搜索
          </el-button>
          <el-button icon="sj-icon-export"
                     @click="resetSearch()">重置
          </el-button>
        </el-form-item>
      </el-form>
    </layout-panel>

    <layout-panel>
      <template slot="header">列表</template>
      <template slot="tools">
        <el-button type="primary"
                   size="small"
                   icon="el-icon-refresh"
                   @click="onRefresh()"></el-button>
      </template>
      <el-table :data="table"
                stripe
                highlight-current-row
                border
                style="width: 100%">
        <el-table-column prop="id"
                         label="ID"
                         min-width="50"></el-table-column>
        <el-table-column prop="display_name"
                         label="名称"
                         min-width="120">
        </el-table-column>
        <el-table-column prop="admin_name"
                         label="发起者"
                         width="100">
          <template slot-scope="scope">
            {{ scope.row.admin_name }} ({{scope.row.admin_id}})
          </template>
        </el-table-column>
        <el-table-column prop="created_at"
                         label="上传时间"
                         min-width="120"></el-table-column>
        <el-table-column label="任务进度"
                         min-width="120">
          <template slot-scope="scope">
            <sj-progress :text-inside="true"
                         :stroke-width="18"
                         :status="taskBatchStatus(scope.row)"
                         :percentages="taskBatchPercentage(scope.row)">
            </sj-progress>
            成功:{{ scope.row.success_count }} 错误:{{ scope.row.error_count }}
          </template>
        </el-table-column>
        <el-table-column prop="task_type"
                         label="任务类型"
                         min-width="120">
          <template slot-scope="scope">
              <span v-for="item in all_tasks"
                    v-if="scope.row.task_type  + '' === item.value + ''">
                <a href="javascript:void(0);"
                   class="link-text"
                   @click="handleTaskClick(item.value, item.collection_id)">
                {{ item.label }}
              </a>
              </span>
          </template>
        </el-table-column>
        <el-table-column prop="customer_name"
                         label="客户"
                         min-width="120">
          <template slot-scope="scope">
            <a href="javascript:void(0);"
               v-if="scope.row.customer_id > 0"
               class="link-text"
               @click="handleCustomerClick(scope.row.customer_id)">
              {{ scope.row.customer_name }} / {{ scope.row.customer_id }}
            </a>
            <span v-else>
              {{ scope.row.customer_name }}
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="collection_type"
                         label="所属队列"
                         min-width="120">
          <template slot-scope="scope">
            <span v-for="item in all_collections"
                  v-if="scope.row.collection_type + '' === item.collection_id + ''">
              <a href="javascript:void(0);"
                 class="link-text"
                 @click="handleCollectionClick(item.collection_id)">
                {{ item.collection_name }}
              </a>
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="status"
                         label="状态"
                         min-width="120">
          <template slot-scope="scope">
              <span v-for="item in status"
                    v-if="scope.row.status === item.value">{{ item.label }}
              </span>
          </template>
        </el-table-column>

      </el-table>
      <div class="pagination">
        <el-pagination background
                       @size-change="handleSizePageChange"
                       @current-change="handleCurrentPageChange"
                       :current-page="pagination.current_page"
                       :page-sizes="[20, 50, 100, 200]"
                       :page-size="pagination.per_page"
                       layout="total, sizes, prev, pager, next, jumper"
                       :total="pagination.total">
        </el-pagination>
      </div>
    </layout-panel>
  </div>
</template>

<script>
import table from '@core/mixins/table'
import taskMixins from '@/views/task/task.mixins'
import SjProgress from '@/components/sj-progress'
import taskBatchMixins from '@/views/task-batch/task-batch.mixins'
import { taskTypes } from '@/views/task-batch/task-batch-opts'

export default {
  mixins: [table, taskMixins, taskBatchMixins],
  components: {SjProgress},
  data () {
    return {
      all_tasks: [
        {'value': 51, 'label': '上传群组门店关系', 'collection_id': 11},
        {'value': 52, 'label': '群组设置目标数', 'collection_id': 11},
        {'value': 53, 'label': '群组批量设置目标数', 'collection_id': 11},
        {'value': 54, 'label': '群组门店关联(执行冲突更新)', 'collection_id': 11},
        {'value': 55, 'label': '单群组设置目标数状态', 'collection_id': 11},
        { ...taskTypes.BATCH_OPEN_TASK_GROUP_BY_SEARCH, collection_id: 11 },
        { ...taskTypes.BATCH_CLOSE_TASK_GROUP_BY_SEARCH, collection_id: 11 },
        {'value': 200, 'label': '批量添加分步模板之替换、选题', 'collection_id': 2},
        {'value': 201, 'label': '批量向用户添加teke标签属性', 'collection_id': 6},
        {'value': 202, 'label': '批量向用户删除teke标签属性', 'collection_id': 6},
        {'value': 203, 'label': '批量修改teke标签', 'collection_id': 6},
        {'value': 204, 'label': '上传teke标签库(包含批量创建teke标签以及批量添加用户)', 'collection_id': 6},
        {'value': 205, 'label': '批量导出teke标签', 'collection_id': 6},
        {'value': 206, 'label': '批量上传活动奖品', 'collection_id': 7},
        {'value': 207, 'label': '批量提现（银行卡/支付宝）', 'collection_id': 5},
        {'value': 208, 'label': '批量任务价格调整（调价批次）', 'collection_id': 2},
        {'value': 209, 'label': '批量添加门店', 'collection_id': 3},
        {'value': 210, 'label': '批量更新门店', 'collection_id': 3},
        {'value': 211, 'label': '批量更新门店(不覆盖)', 'collection_id': 3},
        {'value': 212, 'label': '批量添加平台用户角色', 'collection_id': 8},
        {'value': 213, 'label': '批量删除平台用户角色', 'collection_id': 8},
        {'value': 214, 'label': '批量提现上传批量回滚', 'collection_id': 5},
        {'value': 215, 'label': '按批次通过工单', 'collection_id': 2},
        {'value': 216, 'label': '按批次回收工单', 'collection_id': 2},
        {'value': 217, 'label': '批量添加任务', 'collection_id': 11},
        {'value': 218, 'label': '批量修改任务', 'collection_id': 11},
        {'value': 219, 'label': '批量修改任务可执行时间', 'collection_id': 11},
        {'value': 221, 'label': '按批次审核工单', 'collection_id': 2},
        {'value': 222, 'label': '批量复制任务更改门店', 'collection_id': 11},
        {'value': 223, 'label': '批量门店统计覆盖查询', 'collection_id': 3},
        {'value': 224, 'label': '批量零豆操作', 'collection_id': 1},
        {'value': 225, 'label': '批量标签操作(按手机号)', 'collection_id': 1},
        {'value': 226, 'label': '批量标签操作(注册)', 'collection_id': 1},
        {'value': 227, 'label': '批量修改用户能力&超级零工属性', 'collection_id': 1},
        {'value': 228, 'label': '批量封号', 'collection_id': 1},
        {'value': 229, 'label': '批量修改用户职业属性', 'collection_id': 1},
        {'value': 230, 'label': '批量删除任务', 'collection_id': 2},
        {'value': 231, 'label': '批量添加分步模板', 'collection_id': 2},
        {'value': 232, 'label': '批量修改赏金操作', 'collection_id': 1},
        {'value': 233, 'label': '批量更新平台用户邮箱', 'collection_id': 8},
        {'value': 234, 'label': '批量更新分步模板对应的任务', 'collection_id': 2},
        {'value': 236, 'label': '批量导出任务', 'collection_id': 11},
        {'value': 237, 'label': '批量导出工单', 'collection_id': 11},
        {'value': 238, 'label': '批量导出任务工单', 'collection_id': 11},
        {'value': 239, 'label': '批量导出零工账户信息', 'collection_id': 1},
        {'value': 240, 'label': '批量增加项目批次', 'collection_id': 9},
        {'value': 241, 'label': '批量添加零工用户', 'collection_id': 1},
        {'value': 242, 'label': '批量修改零工用户', 'collection_id': 1},
        {'value': 243, 'label': '批量微信提现', 'collection_id': 5},
        {'value': 246, 'label': '批量更新城市单价（区域管理）', 'collection_id': 3},
        {'value': 249, 'label': '导出零工当前提现金额', 'collection_id': 1},
        {'value': 250, 'label': '导出零工当前账户余额', 'collection_id': 1},
        {'value': 255, 'label': '批量自选职业添加用户', 'collection_id': 1},
        {'value': 256, 'label': '批量自选职业移除用户', 'collection_id': 1},
        {'value': 257, 'label': '批量导出用户(按手机号)', 'collection_id': 1},
        {'value': 258, 'label': '批量导出用户(按ID)', 'collection_id': 1},
        {'value': 259, 'label': '批量导出门店', 'collection_id': 3},
        {'value': 260, 'label': '批量标签操作(按ID)', 'collection_id': 1},
        {'value': 261, 'label': '批量导出省市区关系', 'collection_id': 11},
        {'value': 262, 'label': '按工单解冻oss文件链接', 'collection_id': 2},
        {'value': 263, 'label': '批量添加实习生', 'collection_id': 8},
        {'value': 264, 'label': '批量修改实习生', 'collection_id': 8},
        {'value': 265, 'label': '职业信息批量驳回', 'collection_id': 1},
        { ...taskTypes.USER_TAG_BY_CELLPHONE_SHA256, collection_id: 1 },
        { ...taskTypes.BATCH_EXPORT_RECORD_REMARK, collection_id: 11 },
        { ...taskTypes.BATCH_EXPORT_USER_AUDIT_WORKINFO, collection_id: 11 },
        { ...taskTypes.BATCH_UPDATE_TASK_AFTER_MARKET_MODIFIED, collection_id: 11 },
        { ...taskTypes.BATCH_EXPORT_ORDER_SNEAK_SIMILARITY, collection_id: 11 },
        { ...taskTypes.BATCH_EXPORT_USER_COVERAGE_BY_MARKET_ID, collection_id: 11 },
        { ...taskTypes.BATCH_EXPORT_USER_COVERAGE_BY_GEO, collection_id: 11 },
        { ...taskTypes.BATCH_ADD_TAG_BY_CONDITION, collection_id: 11 },
        { ...taskTypes.BATCH_DEL_TAG_BY_CONDITION, collection_id: 11 },
        { ...taskTypes.BATCH_SUGGEST_PRICE_AND_CREATE_TASK, collection_id: 11 },
        {'value': 277, 'label': '批量添加职业信息公司', 'collection_id': 12},
        {'value': 278, 'label': '批量添加职业信息工种', 'collection_id': 12},
        {'value': 279, 'label': '批量修改目标数', 'collection_id': 13},
        { ...taskTypes.BATCH_ORDER_EXPORT_NEW, collection_id: 11 },
        { ...taskTypes.BATCH_EXPIRE_WORKINFO, collection_id: 12 },
        { ...taskTypes.BATCH_SYNC_PERSONNEL_REQUIREMENT, collection_id: 2 },
        { ...taskTypes.BATCH_TASK_ORDER_EXPORT_NEW, collection_id: 11 },
        { ...taskTypes.BATCH_TASK_EXPORT_NEW, collection_id: 11 },
        { ...taskTypes.BATCH_TASK_AUDIT_REFERENCE, collection_id: 11 },
      ],
      all_collections: [
        {'collection_id': 1, 'collection_name': '用户相关任务(id: 1)'},
        {'collection_id': 2, 'collection_name': '任务相关任务(id: 2)'},
        {'collection_id': 3, 'collection_name': '卖场相关任务(id: 3)'},
        {'collection_id': 5, 'collection_name': '财务相关任务(id: 5)'},
        {'collection_id': 6, 'collection_name': 'teke标签任务(id: 6)'},
        {'collection_id': 7, 'collection_name': '活动相关任务(id: 7)'},
        {'collection_id': 8, 'collection_name': '管理账号相关任务(id: 8)'},
        {'collection_id': 9, 'collection_name': '客户相关任务(id: 9)'},
        {'collection_id': 10, 'collection_name': '中台任务(id: 10)'},
        {'collection_id': 11, 'collection_name': '队列任务(id: 11)'},
        {'collection_id': 12, 'collection_name': '职业信息相关任务(id: 12)'},
        {'collection_id': 13, 'collection_name': '统计管理相关任务(id: 13)'},
      ],
      search: {
        task_type: null,
        collection_type: null,
        status: null,
      },
      searchFieldType: {
        task_type: Number,
        collection_type: Number,
        status: Number,
      }
    }
  },
  computed: Vuex.mapState({
    status: state => state.taskBatch.status,
  }),
  created () {},
  watch: {},
  methods: {
    ...Vuex.mapActions([]),
    getTableData (params) {
      return request.common('queryWaitProcessJobsApi', params)
    },
    handleTaskClick (taskId, collectionId) {
      window.location.href = `?task_type=${taskId}&collection_type=${collectionId}`
    },
    handleCollectionClick (collectionId) {
      window.location.href = `?collection_type=${collectionId}`
    },
    handleCustomerClick (customerId) {
      window.location.href = `?customerid=${customerId}`
    },
    onChangeSelectTaskType (val) {
      if (val) {
        const selectedTask = this.all_tasks.find(task => task.value + '' === val + '')
        if (selectedTask) {
          this.search.collection_type = selectedTask.collection_id
        }
      } else {
        this.search.collection_type = null
      }
    },
    onChangeSelectCollectionType (val) {
      if (val) {
        this.search.task_type = null
      }
    },
  },
}
</script>

<style lang="scss"
       scoped>
.link-text {
  color: #409EFF;
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/batch-jobs/pages/AllBatchJobsTable.vue